// A simple react page to read a csv file from a url and display it in a table

// Perform necessary imports
import React from 'react';
import { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import { RenderDashboardHeader, WaitForData } from '../components/RenderUtils';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';

const AgendaPage=() =>{
    // read csv from remote url
    const [csvData, setCsvData] = useState([]);
    const [loading,setLoading] = useState(true);
    useEffect( () => {
        fetch('/program.csv')
        .then(response => response.text())
        .then(data => {
            const dataArr = data.split(/\r?\n|\r/);
            const headers = dataArr.shift().split(';');
            const rows = dataArr.map( row => {
                const values = row.split(';');
                const eachObject = headers.reduce((obj, header, i) => {
                    obj[header] = values[i];
                    return obj;
                }, {});
                return eachObject;
            })
            setCsvData(rows);
            setLoading(false);
        })
},[]);
console.log(csvData);

if (loading) {
  return (
    <>
    <RenderDashboardHeader subtext="Dagens Program"/>
    <WaitForData show={loading}/>
    </>
  );
}
else {
  // display data in a table
  return (
    <>
    <RenderDashboardHeader subtext="Dagens Program"/>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 350 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className='LessPadding'><strong>Tid</strong></TableCell>
            <TableCell className='LessPadding'><strong>Beskrivelse</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {csvData.map((row, index) => (
           <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              {displayRow(row)}
            </TableRow>
          ))}
        </TableBody>
    </Table>
  </TableContainer>
  </>
  );
}
}


const displayRow = (row) => {
if (row.Time == 'comment') {
return <TableCell align="center" colSpan={2}><em>{row.Description}</em></TableCell>
}
else {
return (<><TableCell  className='LessPadding' component="th" scope="row">
{row.Time}
</TableCell>
<TableCell  className='LessPadding'>{row.Description}</TableCell></>)
}
}
 

export default AgendaPage;